import {Contact} from '../Types/Contact';

// Contenu statique : à remplacer par les vrais interlocuteurs.
export const FIBER_DIRECTOR: Contact = {
  name: 'Cyril Cros',
  title: 'Directeur Fibre et ventes indirectes',
};

export const COMMERCIAL_DIRECTOR: Contact = {
  name: 'Daniel Bedin',
  title: 'Directeur commercial',
  email: 'daniel.bedin@celeste.fr',
};

export const COMMERCIAL_TEAM: Contact[] = [
  {
    name: 'Bertrand Du Bourblanc',
    title: 'Responsable Division Wholesale',
    email: 'bertrand.dubourblanc@celeste.fr',
  },
  {
    name: 'Hadama Tamboura',
    title: 'Ingénieur commercial Wholesale',
    email: 'hadama.tamboura@celeste.fr',
  },
];
